import { useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  useMediaQuery,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "./filter.scss";
import closeIcon from "../../../../assets/icons/close.svg";

const Filter = ({
  categories,
  setFilter,
  filter,
  lang,
  level,
  setIsMobileFilter,
}: any) => {
  const [expandCategory, setExpandCategory] = useState(false);

  const price = [
    { name: "Платный", id: "PAID" },
    { name: "Бесплатный", id: "FREE" },
  ];

  const handleChange = (e: any, type: string) => {
    let temp = [...filter[type]];
    if (filter[type].includes(e.id)) {
      setFilter({ ...filter, [type]: temp.filter((el) => el !== e.id) });
    } else {
      temp.push(e.id);
      setFilter({ ...filter, [type]: temp });
    }
  };

  const resetFilter = () => {
    setFilter({
      category_id: [],
      language_id: [],
      teacher_id: [],
      search: filter.search,
      order_by: [],
      level_id: [],
      price: [],
      limit: [12],
      page: [0],
    });
  };

  const isMobile = useMediaQuery("(max-width:1000px)");

  return (
    <Box className={"filter-wrapper"}>
      {isMobile && (
        <Box className={"filter-title-mobile"}>
          Фильтры
          <img
            src={closeIcon}
            className="closeIcon"
            alt="closeIcon"
            onClick={() => setIsMobileFilter(false)}
          />
        </Box>
      )}
      <Box className={"filter-title"}>Язык</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {lang.map((el: any, index: number) => {
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.language_id.includes(el.id)}
                  onChange={() => handleChange(el, "language_id")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
      </FormGroup>
      <Box className={"filter-title"}>Тема</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {categories.map((el: any, index: number) => {
          if (index > 4 && !expandCategory) {
            return null;
          }
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.category_id.includes(el.id)}
                  onChange={() => handleChange(el, "category_id")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
        <Box
          onClick={() => setExpandCategory(!expandCategory)}
          className={"filter-expand"}>
          {!expandCategory ? (
            <span>
              Показать всё <KeyboardArrowDownIcon />
            </span>
          ) : (
            <span>
              Скрыть <KeyboardArrowUpIcon />
            </span>
          )}
        </Box>
      </FormGroup>

      <Box className={"filter-title"}>Уровень</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {level.map((el: any, index: number) => {
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.level_id.includes(el.id)}
                  onChange={() => handleChange(el, "level_id")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
      </FormGroup>

      <Box className={"filter-title"}>Цена</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {price.map((el: any, index: number) => {
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.price.includes(el.id)}
                  onChange={() => handleChange(el, "price")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
      </FormGroup>

      {!isMobile && (
        <Box
          onClick={() => {
            resetFilter();
          }}
          className={"filter-reset"}>
          Сбросить
        </Box>
      )}

      {isMobile && (
        <Box
          onClick={() => {
            setIsMobileFilter(false);
          }}
          className={"filter-submit"}>
          Применить
        </Box>
      )}
    </Box>
  );
};

export default Filter;
